import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_mst_entity_vehicle_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  regnum: fromDatatype.VarcharDatatypeInterface;
  manufacturer_guid: fromDatatype.GuidDataFieldInterface;
  brand_guid: fromDatatype.GuidDataFieldInterface;
  model_guid: fromDatatype.GuidDataFieldInterface;
  model_variant_guid: fromDatatype.GuidDataFieldInterface;
  engine_guid: fromDatatype.GuidDataFieldInterface;
  year: fromDatatype.IntegerDatatypeInterface;
  chassis_num: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  category: fromDatatype.VarcharDatatypeInterface;
  mileage_latest: fromDatatype.NumericDatatypeInterface;
  mileage_next: fromDatatype.NumericDatatypeInterface;
  repair_last: fromDatatype.TimestampTzDatatypeInterface;
  repair_next: fromDatatype.TimestampTzDatatypeInterface;
  road_tax_start_date: fromDatatype.TimestampTzDatatypeInterface;
  road_tax_end_date: fromDatatype.TimestampTzDatatypeInterface;
  insurance_start_date: fromDatatype.TimestampTzDatatypeInterface;
  insurance_end_date: fromDatatype.TimestampTzDatatypeInterface;
  permit_start_date: fromDatatype.TimestampTzDatatypeInterface;
  permit_end_date: fromDatatype.TimestampTzDatatypeInterface;
  inspection_date: fromDatatype.TimestampTzDatatypeInterface;
  registration_date: fromDatatype.TimestampTzDatatypeInterface;
  capacity: fromDatatype.VarcharDatatypeInterface;
  colour: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  manufacturer_name: fromDatatype.VarcharDatatypeInterface;
  brand_name: fromDatatype.VarcharDatatypeInterface;
  model_name: fromDatatype.VarcharDatatypeInterface;
  model_variant_name: fromDatatype.VarcharDatatypeInterface;
  engine_name: fromDatatype.VarcharDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  delivery_entity_json:fromDatatype.JsonDatatypeInterface;
  billing_json:fromDatatype.JsonDatatypeInterface;
  entity_hdr_json:fromDatatype.JsonDatatypeInterface;
  property_json:fromDatatype.JsonDatatypeInterface;
}

export class bl_fi_mst_entity_vehicle_hdr_RowClass
  implements bl_fi_mst_entity_vehicle_hdr_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  regnum: fromDatatype.VarcharDatatypeInterface;
  manufacturer_guid: fromDatatype.GuidDataFieldInterface;
  brand_guid: fromDatatype.GuidDataFieldInterface;
  model_guid: fromDatatype.GuidDataFieldInterface;
  model_variant_guid: fromDatatype.GuidDataFieldInterface;
  engine_guid: fromDatatype.GuidDataFieldInterface;
  year: fromDatatype.IntegerDatatypeInterface;
  chassis_num: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  category: fromDatatype.VarcharDatatypeInterface;
  mileage_latest: fromDatatype.NumericDatatypeInterface;
  mileage_next: fromDatatype.NumericDatatypeInterface;
  repair_last: fromDatatype.TimestampTzDatatypeInterface;
  repair_next: fromDatatype.TimestampTzDatatypeInterface;
  road_tax_start_date: fromDatatype.TimestampTzDatatypeInterface;
  road_tax_end_date: fromDatatype.TimestampTzDatatypeInterface;
  insurance_start_date: fromDatatype.TimestampTzDatatypeInterface;
  insurance_end_date: fromDatatype.TimestampTzDatatypeInterface;
  permit_start_date: fromDatatype.TimestampTzDatatypeInterface;
  permit_end_date: fromDatatype.TimestampTzDatatypeInterface;
  inspection_date: fromDatatype.TimestampTzDatatypeInterface;
  registration_date: fromDatatype.TimestampTzDatatypeInterface;
  capacity: fromDatatype.VarcharDatatypeInterface;
  colour: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  manufacturer_name: fromDatatype.VarcharDatatypeInterface;
  brand_name: fromDatatype.VarcharDatatypeInterface;
  model_name: fromDatatype.VarcharDatatypeInterface;
  model_variant_name: fromDatatype.VarcharDatatypeInterface;
  engine_name: fromDatatype.VarcharDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  delivery_entity_json:fromDatatype.JsonDatatypeInterface;
  billing_json:fromDatatype.JsonDatatypeInterface;
  entity_hdr_json:fromDatatype.JsonDatatypeInterface;
  property_json:fromDatatype.JsonDatatypeInterface;

}
